export const PhoneValidate = (phone: string) => {
  let message: string;
  if (!phone) {
    message = "شماره موبایل خود را وارد کنید";
    return { isValid: false, message: message };
  } else if (phone.length !== 11) {
    message = "شماره موبایل خود را درست وارد کنید";
    return { isValid: false, message: message };
  } else {
    return { isValid: true, message: "" };
  }
};
export const NumberValidate = (
  value: string,
  active: boolean,
  min: number,
  name: string
) => {
  if (!value && active) {
    const message = `${name} خود را وارد کنید`;
    return { isValid: false, message: message };
  } else if (value.length > min) {
    const message = `${name} خود را درست وارد کنید`;
    return { isValid: false, message: message };
  } else {
    return { isValid: true, message: "" };
  }
};

export const PasswordValidate = (
  password: string,
  rePassword?: string,
  match?: boolean
) => {
  if (!password) {
    const message = "رمز عبور خود را وارد کنید";
    return { isValid: false, message: message };
  } else if (password.length < 7) {
    const message = "رمز عبور شما کوتاه است";
    return { isValid: false, message: message };
  } else if (match && password !== rePassword) {
    const message = "رمز عبور وارد شده مشابه نیستند";
    return { isValid: false, message: message };
  } else {
    return { isValid: true, message: "" };
  }
};

export const MatchPasswordValidate = (password: string, rePassword: string) => {
  if (password !== rePassword) {
    const message = "رمز عبور وارد شده مشابه نیستند";
    return { isValid: false, message: message };
  } else {
    return { isValid: true };
  }
};

export const EmailValidate = (email: string, active?: boolean) => {
  var filter =
    /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

  if (!email && !active) {
    return { isValid: true };
  } else if (!filter.test(email)) {
    const message = "ایمیل خود را صحیح وارد کنید";
    return { isValid: false, message: message };
  } else {
    return { isValid: true };
  }
};

export const ValueValidate = (
  value: string,
  min: number,
  name: string,
  max?: number
) => {
  if (!value) {
    const message = `لطفا ${name} خود را وارد کنید`;
    return { isValid: false, message: message };
  } else if (value.length < min) {
    const message = `${name} شما کوتاه است حداقل ${min} کارکتر وارد کنید`;
    return { isValid: false, message: message };
  } else if (max && value.length > max) {
    const message = `${name} شما حداکثر است حداقل ${min} کارکتر وارد کنید`;
    return { isValid: false, message: message };
  } else {
    return { isValid: true, message: "" };
  }
};

export const ValidateCodeConfirm = (value: string) => {
  if (!value) {
    const message = `لطفا کد خود را وارد کنید`;
    return { isValid: false, message: message };
  } else if (value.length != 6) {
    const message = `کد شما باید ۶ کارکتر باشد`;
    return { isValid: false, message: message };
  } else {
    return { isValid: true, message: "" };
  }
};

export const CheckNameValidate = (
  value: string,
  name: string,
  active?: boolean
) => {
  const p = /^[\u0600-\u06FF\s]+$/;
  if (!value && active) {
    const message = `لطفا ${name} خود را وارد کنید`;
    return { isValid: false, message: message };
  } else if (!p.test(value)) {
    const message = `لطفا ${name} خود را فارسی وارد کنید`;
    return { isValid: false, message: message };
  } else {
    return { isValid: true, message: "" };
  }
};

export const ValuesValidate = (value: string, name: string) => {
  if (!value) {
    const message = `لطفا ${name} خود را وارد کنید`;
    return { isValid: false, message: message };
  } else {
    return { isValid: true, message: "" };
  }
};


export const ValidateComment = (
  firstName: string,
  lastName: string,
  description: string
): string => {
  const { message: msgFistName, isValid: isValidFirstName } = ValueValidate(
    firstName,
    2,
    "نام"
  );
  const { message: msgLastName, isValid: isValidLastName } = ValueValidate(
    lastName,
    2,
    "نام خانوادگی"
  );
  const { message: msgDescription, isValid: isValidDescription } =
    ValueValidate(description, 10, "نظر");
  if (!isValidFirstName) return msgFistName;
  if (!isValidLastName) return msgLastName;
  if (!isValidDescription) return msgDescription;
  return "";
};
